export default __webpack_public_path__ + "static/nextme-491dbbeb8855fd0653b25bed3808e846.jpg";